import React from 'react';
import FolderCard from '@wix/da-shared-react/pkg/FolderCard';
import FolderCardContainer, { OwnProps } from './FolderCard.container';

export default FolderCardContainer(FolderCard) as React.ComponentClass<
  OwnProps
>;
